import { Component } from "react";

import { ErrorDisplay } from "./ErrorDisplay";

interface ErrorBoundaryProps {
  children: React.ReactNode;
  component?: string | undefined;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error?: {
    message?: string;
  };
}

export class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  public state: ErrorBoundaryState = {
    hasError: false,
  };

  public static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return {
      hasError: true,
      error: {
        message: error.message,
      },
    };
  }

  resetError() {
    this.setState({ hasError: false });
  }

  componentDidCatch() {
    this.setState({ hasError: true });
  }

  public render() {
    if (this.state.hasError) {
      return (
        <ErrorDisplay
          title={`Error rendering component`}
          message={this.state.error?.message}
        />
      );
    } else return this.props.children;
  }
}
